/**
 * Editor constants — extracted from creator-web/src/services/constants.js.
 * Only the subset relevant to the 3D editor is included here.
 */

export const AssetTypes = {
  IMAGE: 'Image',
  VIDEO_OPAQUE: 'Video',
  VIDEO_ALPHA: 'VideoAlpha',
  GLB: 'Glb',
} as const;

export type AssetType = typeof AssetTypes[keyof typeof AssetTypes];

export const ControlModeTypes = {
  DEFAULT: 0,
  SELECT: 1,
  NAVIGATE_SCENE: 2, // For click and drag controls
  PRE_TRANSFORM: 3,  // For hover transforming
  TRANSFORM: 4,      // For transforming
} as const;

export type ControlModeType = typeof ControlModeTypes[keyof typeof ControlModeTypes];

export const TransformControlModeTypes = {
  TRANSLATE: 'translate',
  ROTATE: 'rotate',
  SCALE: 'scale',
} as const;

export type TransformControlModeType = typeof TransformControlModeTypes[keyof typeof TransformControlModeTypes];

export const TransformControlsSpaceTypes = {
  WORLD: 'world',
  LOCAL: 'local',
} as const;

export type TransformControlsSpaceType = typeof TransformControlsSpaceTypes[keyof typeof TransformControlsSpaceTypes];

// --- Canvas + camera/scene reference positions (engine-agnostic) ---

/** Default canvas dimensions (fallback when no size is provided to the Editor). */
export const WIDTH = 895;
export const HEIGHT = 761;

/** Camera and scene reference positions (plain {x,y,z} — engine-neutral). */
export const POV_POSITION = { x: 0, y: 0, z: 2 };
export const PANELS_POSITION = { x: 0, y: 0, z: 0 };
export const ORBIT_POSITION = { x: 3, y: 3, z: 4 };

/** Floor grid size (world units, square). */
export const GRID_SIZE = 20;
/**
 * Element positions are clamped to ±this on each axis, keeping elements within
 * the grid. Derived from the grid so resizing the grid moves the bounds with it.
 */
export const SCENE_POSITION_LIMIT = GRID_SIZE / 2;
